import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { PageComponentModule } from '../../../../../cms-structure/page';
import { I18nModule } from '../../../../../core/i18n';
import {
  CatalogArticleListModule,
  DrawerModule,
  DropdownModule,
  GenericLinkModule,
  MediaModule,
  NavSideScrollModule,
  PipesModule,
  ShowPerPageModule,
  SpinnerModule,
} from '../../../../../shared';
import { ActionButtonModule } from '../../../../../shared/components/action-button';
import { BadgeModule } from '../../../../../shared/components/badge';
import { LoadMoreComponent } from '../../../../../shared/components/load-more/load-more.component';
import { SortDropdownModule } from '../../../../../shared/components/sort-dropdown';
import { AssortmentTableModule } from '../../assortment-table';
import { CatalogFilterBreadcrumbsModule } from '../../catalog-filter-breadcrumbs/catalog-filter-breadcrumbs.module';
import { CatalogFilterFacetModule } from '../../catalog-filter-facet/catalog-filter-facet.module';
import { CatalogFilterResetModule } from '../../catalog-filter-reset/catalog-filter-reset.module';
import { CatalogSortModule } from '../../catalog-sort/catalog-sort.module';
import { TechnicalAttributesTableModule } from '../../technical-attributes-table';
import { PdpArticleListTabsComponent } from './pdp-article-list-tabs.component';

@NgModule({
  declarations: [PdpArticleListTabsComponent],
  exports: [PdpArticleListTabsComponent],
  imports: [
    CommonModule,
    NzIconModule,
    I18nModule,
    MediaModule,
    PipesModule,
    NgbNavModule,
    GenericLinkModule,
    LoadMoreComponent,
    AssortmentTableModule,
    TechnicalAttributesTableModule,
    NgbTooltipModule,
    CatalogArticleListModule,
    NavSideScrollModule,
    CatalogFilterFacetModule,
    ActionButtonModule,
    SortDropdownModule,
    ShowPerPageModule,
    CatalogFilterBreadcrumbsModule,
    DropdownModule,
    ReactiveFormsModule,
    BadgeModule,
    DrawerModule,
    CatalogFilterResetModule,
    CatalogSortModule,
    RouterModule,
    PageComponentModule,
    SpinnerModule,
  ],
})
export class PdpArticleListTabsModule {}
